// extracted by mini-css-extract-plugin
export default {"container":"StreamCamera_container__13ttq"};